/*! @pentacode/ui v0.1.0 */
// src/elements/table/table.util.ts
var e = (e) => e.field;
function t(e, t) {
	let n = t.split("."), r = e;
	for (let e of n) r = r?.[e];
	return r;
}
export { e as fieldOf, t as getFieldValue };

//# sourceMappingURL=table.util.js.map